import React from"react";import{Combobox}from"@headlessui/react";export var ComboboxGeneric=function(props){return React.createElement(Combobox,props)};